import { Msg } from '~/common/localizationUtils'
import { Flex, FlexProps, Text, VisuallyHidden } from '~/design_system'

type ResultCountProps = FlexProps & { count: number | undefined; isLoading?: boolean; isFetching?: boolean }
export const ActionBarResultCount = ({
  count = 0,
  isLoading = false,
  isFetching = false,
  ...props
}: ResultCountProps) => {
  if (isLoading) return null

  return (
    <Flex data-action-bar-result-count data-testid="action-bar-result-count" alignItems="center" {...props}>
      <Text as="i" textStyle="subtextSmall" whiteSpace="nowrap" aria-live="polite" aria-atomic="true">
        {isFetching ? (
          <VisuallyHidden>
            <Msg id="common.ui.loading_term" term={<Msg id="common.ui.result" count={2} />} />
          </VisuallyHidden>
        ) : (
          <>
            <VisuallyHidden>
              <Msg id="common.ui.query_returned" />
            </VisuallyHidden>
            <Msg id="common.ui.results" count={count} />
          </>
        )}
      </Text>
    </Flex>
  )
}
